import React, { useEffect } from "react";
import HealthSubpageLayout from "../../../components/HealthSubpageLayout";
import HealthSubpageHeader from "../../../components/HealthSubpageHeader";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import MastercardEstimatedProgramStatusTable from "./Table/MastercardEstimatedProgramStatusTable";
import HealthActions from "../../../reducer";
import { useBusinessAccountId } from "../../../VAMP/hooks/useBusinessAccountId";

const MastercardEstimatedProgramStatusPage = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { monitoringInitialized } = useSelector((state) => state.health);

  const business_account_id = useBusinessAccountId();

  useEffect(() => {
    if (!monitoringInitialized) {
      dispatch(HealthActions.monitoringInit());
    }
  }, []);

  return (
    <HealthSubpageLayout backText={t("Back to Health")}>
      <HealthSubpageHeader title={t("Estimated Program Status")} />
      <MastercardEstimatedProgramStatusTable
        business_account_id={business_account_id}
        variant="page"
        withPagination
        pageSize={5}
      />
    </HealthSubpageLayout>
  );
};

export default MastercardEstimatedProgramStatusPage;
